var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({'text-align': _vm.imgAlign})},[_c('img',{style:({'width': _vm.imgWidth, 'margin-top': _vm.imgMt}),attrs:{"src":_vm.imgSrc}})])}
var staticRenderFns = []

export { render, staticRenderFns }